(function () {
    'use strict';

    angular
        .module('appback')
        .controller('AiCameraCtrl', AiCameraCtrl)

    AiCameraCtrl.$inject = ["$scope", "$timeout", "$uibModal", "$sce", "$http", "GenerallabService", "AiService"];

    function AiCameraCtrl($scope, $timeout, $uibModal, $sce, $http, GenerallabService, AiService) {
        var vm = this;
        console.log("scopeAicamera", $scope);

        vm.modalInstance = null;
        vm.modalResult = null;
        vm.modalPrompt = null;
        vm.generalLab = GenerallabService;

        vm.openResultModal = function () {
            vm.modalInstance = $uibModal.open({
                templateUrl: 'ai-result-modal.html',
                scope: $scope,
                size: 'lg',
                backdrop: 'static'
            });
        };

        vm.closeModal = function () {
            if (vm.modalInstance) {
                vm.modalInstance.dismiss('cancel');
            }
        };

        vm.copyToClipboard = function (elementId) {
            var text = document.getElementById(elementId).innerText;
            navigator.clipboard.writeText(text).then(function () {
                var btn = document.querySelector('.copy-btn');
                var originalText = btn.innerHTML;
                btn.innerHTML = '<i class="fa fa-check"></i> Copied!';
                setTimeout(function () {
                    btn.innerHTML = originalText;
                }, 2000);
            }, function (err) {
                console.error('Could not copy text: ', err);
            });
        }


        vm.showCamera = false;
        vm.selectedModel = 'qwen3-vl:4b-instruct';
        vm.selectedPrompt = "";
        vm.uploadSource = 'device'; // device | database
        vm.cameraStarted = false;
        vm.photoTaken = false;
        vm.imageData = null;
        vm.cameraStream = null;
        vm.initialPrompt = "Eres un experto en parsear información a JSON, necesito transformar el contenido de la imagen en JSON **DEVUELVEME EL CONTENIDO SOLO EN JSON, NUNCA ENVIES NADA QUE NO SEA JSON";
        vm.prompt = vm.initialPrompt;

        vm.getSelectedPrompt = function () {
            if (vm.selectedPrompt != "") {
                AiService.getPrompt(vm.selectedPrompt, function (data) {
                    vm.prompt = data.prompt;
                })
            } else {
                vm.prompt = vm.initialPrompt;
            }
        }

        vm.setInputMethod = function (method) {
            if (method === 'camera') {
                vm.showCamera = true;
                vm.uploadSource = 'device'; // irrelevant but reset
            } else if (method === 'upload') {
                vm.showCamera = false;
                vm.uploadSource = 'device';
                vm.stopCamera();
            } else if (method === 'library') {
                vm.showCamera = false;
                vm.uploadSource = 'database';
                vm.stopCamera();
            }
        };

        function getVideoElement() {
            return document.getElementById('camera-video');
        }

        function getCanvasElement() {
            return document.getElementById('camera-canvas');
        }

        vm.toggleCamera = function () {
            vm.showCamera = !vm.showCamera;
            if (!vm.showCamera) {
                vm.stopCamera();
            }
        };

        vm.startCamera = function () {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ video: true }).then(function (s) {
                    vm.cameraStream = s;
                    var video = getVideoElement();
                    if (video) {
                        video.srcObject = vm.cameraStream;
                        video.play();
                        vm.cameraStarted = true;
                        $timeout(function () {
                            $scope.$apply();
                        });
                    }
                }).catch(function (err) {
                    console.error("Error accessing camera: ", err);
                    alert("Could not access camera. Please allow permissions.");
                });
            } else {
                alert("Camera API not supported in this browser.");
            }
        };

        vm.stopCamera = function () {
            if (vm.cameraStream) {
                vm.cameraStream.getTracks().forEach(function (track) {
                    track.stop();
                });
                vm.cameraStream = null;
            }
            vm.cameraStarted = false;
        };

        vm.takePhoto = function () {
            if (vm.cameraStarted) {
                var video = getVideoElement();
                var canvas = getCanvasElement();

                if (video && canvas) {
                    if (video.videoWidth === 0 || video.videoHeight === 0) {
                        console.warn("Video dimensions are 0, cannot take photo yet.");
                        return;
                    }

                    var context = canvas.getContext('2d');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

                    var data = canvas.toDataURL('image/png');

                    $timeout(function () {
                        vm.imageData = data;
                        console.log("Photo taken, data length:", vm.imageData ? vm.imageData.length : 0);
                        vm.photoTaken = true;

                        // Set hidden input value
                        var input = document.getElementById('camera-image-input');
                        if (input) {
                            input.value = vm.imageData;
                        }

                        vm.stopCamera();
                    });
                }
            }
        };

        vm.retakePhoto = function () {
            vm.photoTaken = false;
            vm.imageData = null;
            var input = document.getElementById('camera-image-input');
            if (input) {
                input.value = '';
            }
            vm.startCamera();
        };
    }

})();
